// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"4c3d83286b0b65b2","8964":"e34fdce27b0b591d"}[chunkId] + ".js";
};